import * as firebase from "firebase";
import { DubitoSvc } from "src/api";
import store from "src/store";
import { setNotifications, fetchNotifications } from "src/store/cases/actions";
export let firebaseApp = null;
export const initializeFirebase = () => {
  firebaseApp = firebase.initializeApp({
    messagingSenderId: "981348547003"
  });

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("./assets/firebase-messaging-sw.js")
      .then(function(registration) {
        firebaseApp.messaging().useServiceWorker(registration);
        initializePush();
        //console.log("This service worker is registered");
        firebaseApp.messaging().onMessage(payload => {
          //console.log(payload);
          registration.showNotification(
            payload.notification.title,
            payload.notification
          );
          store.dispatch(fetchNotifications());
        });
      })
      .catch(function(err) {
        console.log("Service worker registration failed, error:", err);
      });
  }
};
export function initializePush() {
  firebaseApp
    .messaging()
    .requestPermission()
    .then(() => {
      window.localStorage.removeItem("notificationDisabled");
      return firebaseApp.messaging().getToken();
    })
    .then(token => {
      //console.log("FCM Token:", token);
      //send the token to the server to be able to send notifications in the future
      //sendTokenToServer(token);
      DubitoSvc.registerToken(token);
    })
    .catch(error => {
      if (error.code === "messaging/permission-blocked") {
        console.log("Please Unblock Notification Request Manually");
        window.localStorage.setItem("notificationDisabled", "true");
      } else {
        console.log("Error Occurred", error);
      }
    });
}



// WEBPACK FOOTER //
// ./src/util/pushNotification.ts